<!-- 포커칩 정보 -->
<div data-user-popup class="mypokerchip">
  <div class="mypokerchip__head">
    <div class="mypokerchip__title">포커칩정보</div>
    <a class="mypokerchip__close" href="#" onclick="$(this).parents('.mypokerchip').hide(); return false;">닫기</a>
  </div>
  <div class="mypokerchip__box">
    <div class="mypokerchip__box-title">
      소지포커칩
    </div>
    <div class="mypokerchip__chip">
      <span class="icon__pokerchip--big"></span>
      <!-- 보유포커칩 -->
      {{{pchipTag}}}<strong>칩</strong>
    </div>
  </div>
  <div class="mypokerchip__box mypokerchip__box--safe">
    <div class="mypokerchip__box-title">
      금고포커칩
    </div>
    <div class="mypokerchip__chip">
      <span class="icon__pokerchip--big"></span>
      {{#if hasPchipSafebox}}
      <!-- 보유포커칩 -->
      {{{pchipInSafeTag}}}<strong>칩</strong>
      {{else}}
      <!-- 금고 포커칩 없을 때 -->
      <strong>없음</strong><span class="mypokerchip__chip__move-class">[<a href="#" data-user-action="openMallClass">클래스
          상품보기</a>]</span>
      {{/if}}
    </div>
  </div>
  <div class="mypokerchip__tail"></div>
</div>
<!-- //mypokerchip-->